import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import ourapp from '../assets/images/ourapproach.png';
// import brandw from '../assets/images/brandsw.png';
// import redoffice from '../assets/images/redoffice.png'
import Getintouch from '../Gettouch/Getintouch';

// for slick-slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import appslider1 from '../assets/images/approch_banner1.png'
import appslider2 from '../assets/images/approch_banner2.png'
import appslider3 from '../assets/images/approch_banner3.png'
import whoslider4 from '../assets/images/whoslider4.png'



import Slider from "react-slick";
import TextBanner from './TextBanner';

var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow:3,
  // slidesToScroll: 2.5,
  // slidesPerView:1,
  margin: 10,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow:2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow:1,
        slidesToScroll: 2
      }
    }
  ]
};

// for slick-slider end 



const Approach = () => {
  return (
    <>


  {/* new banner dynamic */}

      <TextBanner
          imageUrl={ourapp}
          altname="Our Approach"
          title="We listen, we learn, we craft strategies that sing your brand's tune."  
        />
      {/*  new banner dynamic end */}


    

      <section className='whoslider pt-0'>
        <Container>
          <Row>
            <Col lg={12}>
              <Slider {...settings}>
                <div>
                  <img src={appslider1} alt="Slide1" />
                </div>
                <div>
                  <img src={appslider2} alt="Slide1" />
                </div>
                <div>
                  <img src={appslider3} alt="Slide1" />
                </div>
                <div>
                  <img src={whoslider4} alt="Slide1" />
                </div>

              </Slider>
            </Col>
          </Row>
        </Container>
      </section>


      {/* text only section */}
      <section className='normaltext'>
        <Container>
          <Row>
            <Col lg={10} className='m-auto'>
              <p>At RedCube Digital Media, we believe a robust plan paves the path to digital triumph. That's why our journey begins with understanding your unique needs and goals. </p>
            </Col>
          </Row>
        </Container>
      </section>



      {/* three column section */}

      <section className='thrcolsec'>
        <Container>
          <Row>
            <Col lg={4}>
              <div className='threeBox'>
                <h3>Deep <br/> Dive </h3>    
                <p>Before pixels fly or code compiles, we get to know you. Through a tailored discussion, we uncover your business, audience, and digital aspirations. We then craft a custom plan outlining scope, timeline, and budget, along with strategic tactics like SEO, content marketing, and social media to propel you towards your objectives.</p>            
              </div>                
            </Col>

            <Col lg={4}>
              <div className='threeBox'>
                <h3>Masterful <br/> Execution </h3>    
                <p>With the plan set, our expert team of developers, designers, and marketers springs into action. We collaborate closely, keeping you informed every step of the way, ensuring your vision seamlessly translates into reality. </p>            
              </div>                
            </Col>

            <Col lg={4}>
              <div className='threeBox'>
                <h3>Continuous <br/> Feedback Loop  </h3>    
                <p>Before pixels fly or code compiles, we get to know you. Through a tailored discussion, we uncover your business, audience, and digital aspirations. We then craft a custom plan outlining scope, timeline, and budget, along with strategic tactics like SEO, content marketing, and social media to propel you towards your objectives.</p>            
              </div>                
            </Col>
          </Row>
        </Container>
      </section>

  {/* text only section */}
  <section className='normaltext'>
        <Container>
          <Row>
            <Col lg={11} className='m-auto'>
              <h3><i>Ready to conquer the digital realm? Contact us today for a free consultation and unlock your growth potential!</i></h3>
              <p>We offer a comprehensive range of services, including website design, SEO, PPC, social media marketing, and more. Together, let's craft a digital masterpiece that resonates with your audience and fuels your success. </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* get in touch */}
      <section className='p-0'>
        <Getintouch />
      </section>


      {/* Footer  */}
      <section className='p-0' >
        <Footer />
      </section>
    </>
  );
};

export default Approach;